const btnAudios = [];
const btnPlaying = [];
const audioIDPlay = [];
const audioIDPause = [];

for (let index = 1; index <= 5; index++) {
  btnAudios[index] = document.getElementById("myAudioButton" + index);
  audioIDPlay[index] = document.getElementById("audioIDPlay" + index);
  audioIDPause[index] = document.getElementById("audioIDPause" + index);
  btnPlaying[index] = false;
 // console.log(audioIDPlay[index]);
}

function playAudio(num){
  //console.log('press: ' + num + ' / ' + btnAudios[num]);
  let id = parseInt(num);

  if(!btnPlaying[id]){
    for (let index = 1; index <= 5; index++) {
     // console.log("id: " + id + " / index: " + index);
      
      if(id == index){
       // console.log('Play audio: ' + id);
        btnAudios[id].play();
        btnPlaying[id] = true;

        audioIDPlay[id].style.display = "none";
        audioIDPause[id].style.display = "block";
        
      } else {
         if(btnPlaying[index]){
         // console.log('Another audio was playing, Stop audio: ' + index);
          btnAudios[index].pause();
          btnAudios[index].currentTime = 0;
          btnPlaying[index] = false;

          audioIDPlay[index].style.display = "block";
          audioIDPause[index].style.display = "none";
        }
      }
    }
  } else {
    btnAudios[id].pause();
    btnAudios[id].currentTime = 0;
    btnPlaying[id] = false;

    audioIDPlay[id].style.display = "block";
    audioIDPause[id].style.display = "none";
  }
  
}
